function checkPermission( rota_name, actions=null, permission=null)
{
    //console.log('caiu no permission', rota_name, actions, permission)
    const atuais = permission ? permission : JSON.parse(sessionStorage.getItem("menu")) || []
    let rota = atuais.find( page => page.rota == rota_name )

    //permissão de acesso a rota
    if( rota && !actions )
        return rota.acoes.filter( a => a.status == true ).length > 0

    //permissões de elementos de ações dentro do componente
    if( rota && actions )
    {
        rota = rota.acoes.find( a => a.acao == actions )
        if( rota )return rota.status
        return false
    }

    //console.log(atuais, rota, permission, "auth")
}

export default checkPermission



// WEBPACK FOOTER //
// ./src/helpers/checkPermission.js